import React from 'react';

interface Props {
  breakdown: {
    earnings: string | null;
    contributions: string | null;
    distributions: string | null;
    payment: string | null;
    interest: string | null;
    investmentIncomeTax: string | null;
    capitalGainsTax: string | null;
    costBasis: string | null;
    exerciseCost: string | null;
    unmetEstateObligation: string | null;
  };
  style: Record<string, any>;
}

export const ProjectedBalanceSheetBreakdown: React.FC<Props> = ({ breakdown, style }) => {
  if (Object.values(breakdown).every(val => !val)) {
    return null;
  }

  return (
    <div className="breakdown" style={style}>
      <table>
        <tbody>
          {!!breakdown.earnings && (
            <tr>
              <td className="bold">Earnings</td>
              <td>{breakdown.earnings}</td>
            </tr>
          )}

          {!!breakdown.contributions && (
            <tr>
              <td className="bold">Contributions</td>
              <td>{breakdown.contributions}</td>
            </tr>
          )}

          {!!breakdown.distributions && (
            <tr>
              <td className="bold">Distributions</td>
              <td>{breakdown.distributions}</td>
            </tr>
          )}

          {!!breakdown.payment && (
            <tr>
              <td className="bold">Payments</td>
              <td>{breakdown.payment}</td>
            </tr>
          )}

          {!!breakdown.interest && (
            <tr>
              <td className="bold">Interest</td>
              <td>{breakdown.interest}</td>
            </tr>
          )}

          {!!breakdown.investmentIncomeTax && (
            <tr>
              <td className="bold">Short-Term Capital Gains Tax</td>
              <td>{breakdown.investmentIncomeTax}</td>
            </tr>
          )}

          {!!breakdown.capitalGainsTax && (
            <tr>
              <td className="bold">Long-Term Capital Gains Tax</td>
              <td>{breakdown.capitalGainsTax}</td>
            </tr>
          )}

          {!!breakdown.costBasis && (
            <tr>
              <td className="bold">Cost Basis</td>
              <td>{breakdown.costBasis}</td>
            </tr>
          )}

          {!!breakdown.exerciseCost && (
            <tr>
              <td className="bold">Exercise Cost</td>
              <td>{breakdown.exerciseCost}</td>
            </tr>
          )}

          {!!breakdown.unmetEstateObligation && breakdown.unmetEstateObligation !== '$0' && (
            <tr>
              <td className="bold" style={{ whiteSpace: 'nowrap' }}>
                Unmet Estate Obligations
              </td>
              <td>{breakdown.unmetEstateObligation}</td>
            </tr>
          )}
        </tbody>
      </table>
    </div>
  );
};
